<template>
  <div class="dropShadowMd pb-5">
    <AppDataProperty
      contentId="isLockedData"
      @dataAvailable="
        data => {
          accountLockedData = data
        }
      "
      isComponent
    />
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <div class="py-3"></div>
    <div class="px-6 text-3xl font-bold">Services</div>
    <div class="py-1"></div>
    <div class="" ref="servicesContainer">
      <div class="w-full overflow-auto px-6">
        <div class="min-w-max flex gap-2">
          <div
            class="flex flex-col items-center gap-2 rounded-xl ripple min-w-[25vw] p-2"
            @click="$Events.dispatchEvent('start_tv_required')"
          >
            <div
              class="w-[20vw] h-[20vw] bg-white bg-opacity-5 border-transparent rounded-full border-2"
            >
              <img
                src="/images/servicesCategories/football.png"
                alt=""
                class="w-full h-full object-contain"
              />
            </div>
            <div>Sport Tv</div>
          </div>
          <div
            class="flex flex-col items-center gap-2 rounded-xl ripple min-w-[25vw] p-2"
            v-for="(category, i) in categories"
            :key="i"
            @click="selectCategory(category)"
          >
            <div
              class="w-[20vw] h-[20vw] bg-white bg-opacity-5 rounded-full border-2"
              :class="{
                'border-primary': category.id == selectedCategory.id,
                'border-transparent': category.id !== selectedCategory.id,
              }"
            >
              <img
                :src="category.image"
                alt=""
                class="w-full h-full object-contain"
              />
            </div>
            <div>{{ category.name }}</div>
          </div>
        </div>
      </div>
      <div class="py-3"></div>
      <div class="px-6 text-2xl font-bold">
        {{ selectedCategory.name }}
      </div>
      <div
        v-if="
          selectedCategory.id == 'fund' || selectedCategory.id == 'withdraw'
        "
      >
        <div class="py-2"></div>
        <div class="grid grid-cols-11 gap-4 h-full px-6 pt-0">
          <div
            v-for="(bookmaker, i) in bookmakers"
            :key="i"
            :class="{
              'row-span-4 col-span-7 0': i == 0,
              'row-span-4 col-span-4 1': i == 1,
              'row-span-4 col-span-5 2': i == 2,
              'row-span-4 col-span-6 3': i == 3,
              'row-span-4 col-span-6 4': i == 4,
              'row-span-4 col-span-5 5': i == 5,
              'row-span-4 col-span-5 6': i == 6,
              'row-span-4 col-span-6 7': i == 7,
              'row-span-4 col-span-6 8': i == 8,
              'row-span-4 col-span-5 9': i == 9,
            }"
          >
            <div
              class="min-h-[18lvh] w-full h-full rounded-3xl overflow-hidden flex flex-col ripple"
              :style="{ backgroundColor: bookmaker.backgroundColor }"
              @click="onServiceClick(bookmaker.id, selectedCategory.id)"
            >
              <div class="absolute w-full h-full">
                <img
                  src="@/assets/images/backgrounds/bg1.svg"
                  alt=""
                  v-if="true"
                  class="w-full h-full object-cover"
                  :class="{
                    'opacity-10': i == 0,
                    'opacity-30': i !== 0,
                  }"
                />
                <img
                  v-else
                  src="@/assets/images/backgrounds/bg1-black.svg"
                  alt=""
                  class="w-full h-full object-cover opacity-50"
                />
              </div>
              <div class="right-0 p-4 absolute">
                <div
                  class="rounded-full bg-white bg-opacity-40 relative"
                  :class="{
                    'w-[6svh] h-[6svh] p-3': true,
                  }"
                >
                  <div
                    class="absolute w-full h-full bg-white scale-[1.9] opacity-20 rounded-full top-0 left-0"
                  ></div>
                  <img
                    :src="bookmaker?.image"
                    class="object-contain w-full h-full rotate-[-10deg] rounded-lg"
                    :class="{
                      'scale-[4] -translate-y-2/3': bookmaker.id === 'food',
                      'scale-[2] ': bookmaker.id === 'subscription',
                    }"
                  />
                </div>
              </div>
              <div class="mt-auto p-4 relative">
                <!-- <div
                  class="font-bold text-white"
                  :class="{ 'text-4xl': i == 0, 'text-xl': i !== 0 }"
                >
                  {{ bookmaker.name }}
                </div> -->
                <div
                  :class="{
                    'text-lg': i == 0,
                  }"
                >
                  {{ bookmaker.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedCategory.id == 'subscriptions'">
        <div class="py-2"></div>
        <div class="grid grid-cols-11 gap-4 h-full px-6 pt-0">
          <div
            v-for="(subscription, i) in subscriptions"
            :key="i"
            :class="{
              'row-span-4 col-span-7 0': i == 0,
              'row-span-4 col-span-4 1': i == 1,
              'row-span-4 col-span-5 2': i == 2,
              'row-span-4 col-span-6 3': i == 3,
              'row-span-4 col-span-6 4': i == 4,
              'row-span-4 col-span-5 5': i == 5,
              'row-span-4 col-span-5 6': i == 6,
              'row-span-4 col-span-6 7': i == 7,
              'row-span-4 col-span-6 8': i == 8,
              'row-span-4 col-span-5 9': i == 9,
            }"
          >
            <div
              class="min-h-[15lvh] w-full h-full rounded-3xl overflow-hidden flex flex-col ripple"
              :style="{ backgroundColor: subscription.backgroundColor }"
              @click="onServiceClick('subscription', subscription.id)"
            >
              <div class="absolute w-full h-full">
                <img
                  src="@/assets/images/backgrounds/bg1.svg"
                  alt=""
                  v-if="true"
                  class="w-full h-full object-cover"
                  :class="{
                    'opacity-10': i == 0,
                    'opacity-30': i !== 0,
                  }"
                />
                <img
                  v-else
                  src="@/assets/images/backgrounds/bg1-black.svg"
                  alt=""
                  class="w-full h-full object-cover opacity-50"
                />
              </div>
              <div class="right-0 p-4 absolute">
                <div
                  class="rounded-full bg-white bg-opacity-40 relative"
                  :class="{
                    'w-[6svh] h-[6svh] p-3': true,
                  }"
                >
                  <div
                    class="absolute w-full h-full bg-white scale-[1.9] opacity-20 rounded-full top-0 left-0"
                  ></div>
                  <img
                    :src="subscription?.image"
                    class="object-contain w-full h-full rotate-[-10deg] rounded-lg"
                    :class="{
                      'scale-[4] -translate-y-2/3': subscription.id === 'food',
                      'scale-[2] ': subscription.id === 'subscription',
                    }"
                  />
                </div>
              </div>
              <div class="mt-auto p-4 relative">
                <div
                  class="font-bold text-white"
                  :class="{ 'text-4xl': i == 0, 'text-xl': i !== 0 }"
                >
                  {{ subscription.name }}
                </div>
                <div
                  :class="{
                    'text-white': i == 2,
                    'text-xl': i == 0,
                    'text-sm': i !== 0,
                  }"
                >
                  {{ subscription.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedCategory.id == 'gift'">
        <div class="py-2"></div>
        <div class="grid grid-cols-11 gap-4 h-full px-6 pt-0">
          <div
            v-for="(giftCard, i) in giftCards"
            :key="i"
            :class="{
              'row-span-4 col-span-6 0': i == 0,
              'row-span-4 col-span-5 1': i == 1,
              'row-span-4 col-span-5 2': i == 2,
              'row-span-4 col-span-6 3': i == 3,
              'row-span-4 col-span-6 4': i == 4,
              'row-span-4 col-span-5 5': i == 5,
              'row-span-4 col-span-5 6': i == 6,
              'row-span-4 col-span-6 7': i == 7,
              'row-span-4 col-span-6 8': i == 8,
              'row-span-4 col-span-5 9': i == 9,
            }"
          >
            <div
              class="min-h-[18lvh] w-full h-full rounded-3xl overflow-hidden flex flex-col ripple"
              :style="{ backgroundColor: giftCard.backgroundColor }"
              @click="onServiceClick('usdt', giftCard.option)"
            >
              <div class="absolute w-full h-full">
                <img
                  src="@/assets/images/backgrounds/bg1.svg"
                  alt=""
                  v-if="true"
                  class="w-full h-full object-cover"
                  :class="{
                    'opacity-10': i == 0,
                    'opacity-30': i !== 0,
                  }"
                />
                <img
                  v-else
                  src="@/assets/images/backgrounds/bg1-black.svg"
                  alt=""
                  class="w-full h-full object-cover opacity-50"
                />
              </div>
              <div class="right-0 p-4 absolute">
                <div
                  class="rounded-full bg-white bg-opacity-40 relative"
                  :class="{
                    'w-[6svh] h-[6svh] p-3': true,
                  }"
                >
                  <div
                    class="absolute w-full h-full bg-white scale-[1.9] opacity-20 rounded-full top-0 left-0"
                  ></div>
                  <img
                    :src="giftCard?.image"
                    class="object-contain w-full h-full rotate-[-10deg] rounded-lg"
                    :class="{
                      'scale-[4] -translate-y-2/3': giftCard.id === 'food',
                      'scale-[2] ': giftCard.id === 'subscription',
                    }"
                  />
                </div>
              </div>
              <div class="mt-auto p-4 relative">
                <div class="font-bold text-2xl text-white">
                  {{ giftCard.name }}
                </div>
                <div
                  :class="{
                    'text-lg': i == 0,
                  }"
                >
                  {{ giftCard.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedCategory.id == 'crypto'">
        <div class="py-2"></div>
        <div class="grid grid-cols-11 gap-4 h-full px-6 pt-0">
          <div
            v-for="(crypto, i) in crypto"
            :key="i"
            :class="{
              'row-span-4 col-span-6 0': i == 0,
              'row-span-4 col-span-5 1': i == 1,
              'row-span-4 col-span-5 2': i == 2,
              'row-span-4 col-span-6 3': i == 3,
              'row-span-4 col-span-6 4': i == 4,
              'row-span-4 col-span-5 5': i == 5,
              'row-span-4 col-span-5 6': i == 6,
              'row-span-4 col-span-6 7': i == 7,
              'row-span-4 col-span-6 8': i == 8,
              'row-span-4 col-span-5 9': i == 9,
            }"
          >
            <div
              class="min-h-[18lvh] w-full h-full rounded-3xl overflow-hidden flex flex-col ripple"
              :style="{ backgroundColor: crypto.backgroundColor }"
              @click="onServiceClick('usdt', crypto.option)"
            >
              <div class="absolute w-full h-full">
                <img
                  src="@/assets/images/backgrounds/bg1.svg"
                  alt=""
                  v-if="true"
                  class="w-full h-full object-cover"
                  :class="{
                    'opacity-10': i == 0,
                    'opacity-30': i !== 0,
                  }"
                />
                <img
                  v-else
                  src="@/assets/images/backgrounds/bg1-black.svg"
                  alt=""
                  class="w-full h-full object-cover opacity-50"
                />
              </div>
              <div class="right-0 p-4 absolute">
                <div
                  class="rounded-full bg-white bg-opacity-40 relative"
                  :class="{
                    'w-[6svh] h-[6svh] p-3': true,
                  }"
                >
                  <div
                    class="absolute w-full h-full bg-white scale-[1.9] opacity-20 rounded-full top-0 left-0"
                  ></div>
                  <img
                    :src="crypto?.image"
                    class="object-contain w-full h-full rotate-[-10deg] rounded-lg"
                    :class="{
                      'scale-[4] -translate-y-2/3': crypto.id === 'food',
                      'scale-[2] ': crypto.id === 'subscription',
                    }"
                  />
                </div>
              </div>
              <div class="mt-auto p-4 relative">
                <div class="font-bold text-2xl text-white">
                  {{ crypto.name }}
                </div>
                <div
                  :class="{
                    'text-lg': i == 0,
                  }"
                >
                  {{ crypto.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedCategory.id == 'messages'">
        <div class="py-2"></div>
        <div class="grid grid-cols-11 gap-4 h-full px-6 pt-0">
          <div
            :class="{
              'row-span-4 col-span-6 0': true,
            }"
          >
            <a
              class="min-h-[18lvh] w-full h-full rounded-3xl overflow-hidden flex flex-col ripple"
              :style="{ backgroundColor: '#36B4E3' }"
              target="_blank"
              :href="
                isGa
                  ? 'https://t.me/kingrecharge_bet_bot'
                  : 'https://t.me/kingrecharges_ga_bot'
              "
            >
              <div class="absolute w-full h-full">
                <img
                  src="@/assets/images/backgrounds/bg1.svg"
                  alt=""
                  class="w-full h-full object-cover"
                  :class="{
                    'opacity-10': i == 0,
                    'opacity-30': i !== 0,
                  }"
                />
              </div>
              <div class="right-0 p-4 absolute">
                <div
                  class="rounded-full bg-white bg-opacity-40 relative"
                  :class="{
                    'w-[6svh] h-[6svh] p-3': true,
                  }"
                >
                  <div
                    class="absolute w-full h-full bg-white scale-[1.9] opacity-20 rounded-full top-0 left-0"
                  ></div>
                  <img
                    :src="telegramIcon"
                    class="object-contain w-full h-full rotate-[-10deg] rounded-lg"
                  />
                </div>
              </div>
              <div class="mt-auto p-4 relative">
                <div class="font-bold text-2xl text-white">Télégram</div>
                <div
                  :class="{
                    'text-lg': i == 0,
                  }"
                >
                  Utilisez kingrecharge sur télégram
                </div>
              </div>
            </a>
          </div>
          <div
            :class="{
              'row-span-4 col-span-5 1': true,
            }"
          >
            <div
              class="min-h-[18lvh] w-full h-full rounded-3xl overflow-hidden flex flex-col ripple"
              :style="{ backgroundColor: '#24CC63' }"
              @click="onServiceClick('whatsapp')"
            >
              <div class="absolute w-full h-full">
                <img
                  src="@/assets/images/backgrounds/bg1.svg"
                  alt=""
                  class="w-full h-full object-cover"
                  :class="{
                    'opacity-10': i == 0,
                    'opacity-30': i !== 0,
                  }"
                />
              </div>
              <div class="right-0 p-4 absolute">
                <div
                  class="rounded-full bg-white bg-opacity-40 relative"
                  :class="{
                    'w-[6svh] h-[6svh] p-3': true,
                  }"
                >
                  <div
                    class="absolute w-full h-full bg-white scale-[1.9] opacity-20 rounded-full top-0 left-0"
                  ></div>
                  <img
                    :src="whatsappIcon"
                    class="object-contain w-full h-full rotate-[-10deg] rounded-lg"
                  />
                </div>
              </div>
              <div class="mt-auto p-4 relative">
                <div class="font-bold text-2xl text-white">Whatsapp</div>
                <div
                  :class="{
                    'text-lg': i == 0,
                  }"
                >
                Bientot disponible
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-6"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from '../appData/AppDataProperty.vue'

import xBetIco from '../../assets/images/services/1xBetIco.svg'
import betwinner from '../../assets/images/services/betwinner-full.png'
import melbetIcon from '../../assets/images/services/melbetIcon.svg'
import usdtIcon from '../../assets/images/services/usdtIcon.svg'
import oneWinIcon from '../../assets/images/all/1winIcon.svg'
import giftCardImage from '../../assets/images/all/gift-card-white.svg'
import pmIcon from '../../assets/images/services/pmIcon.svg'
import more from '../../assets/images/services/more-service.webp'
import telegramIcon from '@/assets/images/all/telegram-white.svg'
import whatsappIcon from '@/assets/images/all/whatsapp-white.svg'
import foodIcon from '../../assets/images/all/salade.png'
import subscribtionIcon from '../../assets/images/all/sabonner.png'

import netflixIcon from '@/assets/images/all/netflix.svg'
import primeVideoIcon from '@/assets/images/all/prime-video.svg'
import disneyIcon from '@/assets/images/all/disney-plus.svg'
import crunchyrollIcon from '@/assets/images/all/crunchyroll.svg'
import spotifyIcon from '@/assets/images/all/spotify.svg'
import nordvpnIcon from '@/assets/images/all/nordvpn.svg'
import privatevpnIcon from '@/assets/images/all/privatevpn.png'
import cyberghostIcon from '@/assets/images/all/cyberghost.webp'
import adnIcon from '@/assets/images/all/adn.svg'
import UserProperty from '../user/UserProperty.vue'

export default defineComponent({
  name: 'ServicesGroupComponent',
  components: { AppDataProperty, UserProperty },
  props: {},
  data() {
    return {
      userData: {},
      selectedCategory: { name: 'Abonnements', id: 'subscriptions' },
      categories: [
        {
          name: 'Abonnements',
          id: 'subscriptions',
          image: '/images/servicesCategories/netflix.png',
        },
        {
          name: 'Recharges',
          id: 'fund',
          image: '/images/servicesCategories/recharge.png',
        },
        {
          name: 'Retraits',
          id: 'withdraw',
          image: '/images/servicesCategories/retrait.png',
        },
        {
          name: 'Crypto',
          id: 'crypto',
          image: '/images/servicesCategories/cryptocurrency.png',
        },
        {
          name: 'Cartes Cadeaux',
          id: 'gift',
          image: '/images/servicesCategories/gift-card.png',
        },
        {
          name: 'Chat Bot',
          id: 'messages',
          image: '/images/servicesCategories/chatbot.png',
        },
      ],
      bookmakers: [
        {
          id: '1xbet',
          name: '1xBet',
          description: 'Recharge ton compte 1xBet rapidement',
          pretitle: '',
          image: xBetIco,
          backgroundColor: '#002E5E',
        },
        {
          id: 'betwinner',
          name: 'Betwinner',
          description: 'Betwinner Disponible et sécurisé',
          pretitle: '',
          image: betwinner,
          backgroundColor: '#1F7E5C',
        },
        {
          id: '1win',
          name: '1Win',
          description: 'Nous avons aussi 1Win chez nous',
          pretitle: 'Nouveau',
          image: oneWinIcon,
          backgroundColor: '#080E1E',
        },
        {
          id: 'melbet',
          name: 'Melbet',
          description: 'Bientot Melbet sera disponible',
          pretitle: '',
          image: melbetIcon,
          backgroundColor: '#272727',
        },
      ],
      telegramIcon,
      whatsappIcon,
      giftCardImage,
      usdtIcon,
      subscriptions: [
        {
          id: 'netflix',
          backgroundColor: '#3A1E1E',
          name: 'Netflix',
          image: netflixIcon,
        },
        {
          id: 'prime-video',
          backgroundColor: '#0E4A7A',
          name: 'Prime Video',
          image: primeVideoIcon,
        },
        {
          id: 'disney-plus',
          backgroundColor: '#0A1A5C',
          name: 'Disney Plus',
          image: disneyIcon,
        },
        {
          id: 'crunchyroll',
          backgroundColor: '#1A0D00',
          name: 'Crunchirol',
          image: crunchyrollIcon,
        },
        {
          id: 'spotify',
          backgroundColor: '#1E2A1E',
          name: 'Spotify',
          image: spotifyIcon,
        },
        {
          id: 'nordvpn',
          backgroundColor: '#1A2E5C',
          name: 'Nord Vpn',
          image: nordvpnIcon,
        },
        {
          id: 'privatevpn',
          backgroundColor: '#1A0D00',
          name: 'Private Vpn',
          image: privatevpnIcon,
        },
        {
          id: 'cyberghost',
          backgroundColor: '#1A1400',
          name: 'CyberGhost',
          image: cyberghostIcon,
        },
        { id: 'adn', backgroundColor: '#1A0000', name: 'ADN', image: adnIcon },
      ],
      crypto: [
        {
          id: 'usdt',
          option: 'buy',
          backgroundColor: '#55AD94',
          name: 'Achat de usdt',
          image: usdtIcon,
        },
        {
          id: 'usdt',
          option: 'sell',
          backgroundColor: '#55AD94',
          name: 'Vente de usdt',
          image: usdtIcon,
        },
      ],
      giftCards: [
        {
          id: 'usdt',
          option: 'buy',
          backgroundColor: '#e76f51',
          name: 'Achetez vos cartes cadeux',
          image: giftCardImage,
        },
        {
          id: 'usdt',
          option: 'sell',
          backgroundColor: '#e76f51',
          name: 'Ventes cartes cadeux',
          image: giftCardImage,
        },
      ],
      services: [
        {
          id: '1xbet',
          name: '1xBet',
          description: 'Dépots & Retraits',
          logo: xBetIco,
          color: '#002E5E',
          isAvailable: true,
          isDarkBg: true,
        },
        {
          id: 'betwinner',
          name: 'Betwinner',
          description: 'Dépots & Retraits',
          logo: betwinner,
          color: '#1F7E5C',
          isAvailable: true,
          isDarkBg: true,
        },
        {
          id: 'melbet',
          name: 'Melbet',
          description: 'Dépots & Retraits',
          logo: melbetIcon,
          color: '#272727',
          isAvailable: false,
          isDarkBg: true,
        },
        {
          id: '1win',
          name: '1Win',
          description: 'Dépots & Retraits',
          logo: oneWinIcon,
          color: '#080E1E',
          isAvailable: true,
          isDarkBg: true,
        },
        {
          id: 'giftCard',
          name: 'Cartes Cadeaux',
          description: 'Achat & Vente',
          logo: giftCardImage,
          color: '#e76f51',
          isAvailable: true,
          isDarkBg: false,
        },
        {
          id: 'usdt',
          name: 'USDT',
          description: 'Achat & Vente',
          logo: usdtIcon,
          color: '#55AD94',
          isAvailable: true,
          isDarkBg: false,
        },
        {
          id: 'food',
          name: 'Un petit creu ?',
          description: 'Commandez vos repas ',
          logo: foodIcon,
          color: '#492323',
          isAvailable: false,
          isDarkBg: true,
          notAvailableMessage:
            'La commande de repas est bientot disponible chez vous',
        },
        {
          id: 'subscription',
          name: 'Abonnements',
          description: 'Vos abonnements facile',
          logo: subscribtionIcon,
          color: '#354E92',
          isAvailable: true,
          isDarkBg: true,
          notAvailableMessage:
            'La commande de repas est bientot disponible chez vous',
        },
        {
          id: 'telegram',
          name: 'Télégram',
          description: 'Utiliser sur télégram',
          logo: telegramIcon,
          color: '#36B4E3',
          isAvailable: true,
          isDarkBg: false,
          url: 'https://t.me/kingrecharge_bet_bot',
        },
        {
          id: 'whatsapp',
          name: 'Whatsapp',
          description: 'Utiliser sur whatsapp',
          logo: whatsappIcon,
          color: '#24CC63',
          isAvailable: false,
          isDarkBg: false,
        },
      ],
      lockServices: false,
      makeCardAnim: false,
      accountLockedData: {},
    }
  },
  mounted() {},
  methods: {
    selectCategory(category) {
      this.selectedCategory = category
      this.$refs.servicesContainer.scrollIntoView()
      setTimeout(() => {
        this.$refs.servicesContainer.scrollIntoView()
      }, 300)
    },
    onServiceClick(serviceId, option) {
      if (this.lockServices) return
      if (this.accountLockedData?.metaData?.isLocked) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Compte bloqué',
          body: 'Votre compte a été bloqué, vous ne pouvez plus accéder aux services. Contactez nous depuis le menu Support ',
          type: 'info',
        })
        return
      }
      const serviceData = this.services.find(service => service.id == serviceId)
      if (serviceData.url) return
      if (!serviceData?.isAvailable) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Bientot Disponible',
          body:
            serviceData.notAvailableMessage ||
            serviceData.name + " n'est pas disponible dans votre région",
          type: 'info',
        })
        this.lockServices = false
        return
      }
      console.log(serviceId, option)
      this.$Events.dispatchEvent('service_launching_requested', {
        serviceId,
        option,
      })
      this.lockServices = true
      setTimeout(() => {
        this.lockServices = false
      }, 1000)
    },
  },
  computed: {
    isGa() {
      if (!this.userData?.phoneNumber) return false
      return this.userData.phoneNumber.startsWith('241')
    },
  },
})
</script>
